/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Report_FeedbackInputs */



/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Practice_Report_FeedbackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_report_feedback = /** @type {((inputs?: Practice_Report_FeedbackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Report_FeedbackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Feedback")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Feedback")
	return /** @type {LocalizedString} */ ("Feedback")
});